import '../styles/faq.scss';

class FaqItem {
    /**
     * @param {HTMLElement} item
     */
    constructor(item) {
        this.item = item;
        this.button = item.querySelector('.f-faq__item-toggle');

        if (!this.button) {
            return;
        }

        const controlsId = this.button.getAttribute('aria-controls');
        this.content = controlsId ? this.item.querySelector(`#${CSS.escape(controlsId)}`) : null;

        if (!this.content) {
            return;
        }

        this.item.addEventListener('click', (event) => this.handleClick(event));
    }

    handleClick(event) {
        if (this.content.contains(event.target)) {
            return;
        }

        this.toggle();
    }

    toggle() {
        const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
        this.setState(!isExpanded);
    }

    setState(open) {
        this.button.setAttribute('aria-expanded', String(open));

        if (open) {
            this.content.removeAttribute('aria-hidden');
            this.content.removeAttribute('inert');
            if (this.item) {
                this.item.classList.add('is-open');
            }
        } else {
            this.content.setAttribute('aria-hidden', 'true');
            this.content.setAttribute('inert', '');
            if (this.item) {
                this.item.classList.remove('is-open');
            }
        }
    }
}

function initFaq() {
    const items = document.querySelectorAll('.f-faq__item:not([data-faq-initialized])');

    items.forEach((item) => {
        item.setAttribute('data-faq-initialized', 'true');
        new FaqItem(item);
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaq);
} else {
    initFaq();
}

export { FaqItem, initFaq };
